<template lang="pug">
  .abilityGroup
    p.abilityGroup__title 公告
    .abilityGroup__item
      span.abilityGroup__subtitle 公告頁面
      BaseAbilityRadioGroup(
        :value="abilityAnnouncement"
        :disabled="disabled"
        @handleRadioChange="setAbilityAnnouncement")
</template>
<script>
import BaseAbilityRadioGroup from '@/components/common/select/BaseAbilityRadioGroup'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      abilityAnnouncement: 'positionStore/getCurrentAbilityAnnouncement',
    }),
  },
  methods: {
    ...mapActions({
      setAbilityAnnouncement: 'positionStore/setAbilityAnnouncement',
    }),
  },
  components: {
    BaseAbilityRadioGroup,
  },
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_abilityGroup';
</style>



// WEBPACK FOOTER //
// src/pages/manager/AbilityRadioGroup/AbilityGroupAnnouncement.vue